import { Connector }        from '@mathquis/modelx';
import { ConnectorResult }  from '@mathquis/modelx';
import { ConnectorResults } from '@mathquis/modelx';
import { Model }            from '@mathquis/modelx';
import { getSharedItem }            from 'tools/sharedAuthCookie';
import { removeSharedItem }         from 'tools/sharedAuthCookie';
import { setSharedItem }            from 'tools/sharedAuthCookie';
import { SHARED_REFRESH_TOKEN_KEY } from 'tools/sharedAuthCookie';
import { SHARED_TOKEN_KEY }         from 'tools/sharedAuthCookie';

// Persiste token / refreshToken dans les cookies partagés entre les backoffices JTS (format widesk-core)
export default class SharedAuthCookieConnector extends Connector {
	public list(): Promise<ConnectorResults> {
		return Promise.reject(new Error('SharedAuthCookieConnector does not support list'));
	}

	public fetch(): Promise<ConnectorResult> {
		const token = getSharedItem(SHARED_TOKEN_KEY);
		const refreshToken = getSharedItem(SHARED_REFRESH_TOKEN_KEY);

		if (!token && !refreshToken) {
			return Promise.reject(new Error('No shared session'));
		}

		return Promise.resolve(new ConnectorResult({ token: token || '', refreshToken: refreshToken || '' }));
	}

	public save(model: Model): Promise<ConnectorResult> {
		const { token, refreshToken } = model.untransformedAttributes as { token?: string, refreshToken?: string };

		this._write(SHARED_TOKEN_KEY, token);
		this._write(SHARED_REFRESH_TOKEN_KEY, refreshToken);

		// Renvoie tous les attributs : ModelX les réapplique au modèle (user_data ne doit pas être perdu)
		return Promise.resolve(new ConnectorResult(model.untransformedAttributes));
	}

	public destroy(model: Model): Promise<ConnectorResult> {
		removeSharedItem(SHARED_TOKEN_KEY);
		removeSharedItem(SHARED_REFRESH_TOKEN_KEY);

		return Promise.resolve(new ConnectorResult(model.untransformedAttributes));
	}

	private _write(name: string, value?: string) {
		if (value) {
			setSharedItem(name, value);
		} else {
			removeSharedItem(name);
		}
	}
}
